/*
 * Copyright (c) 2019 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/util/util';
import Component from 'can/component/component';
import template from './cell-live.stache';

import liveVideoService from 'scripts/services/live-video-service';
import stringUtil from 'scripts/utils/string';
import dateTimeUtil from 'scripts/utils/date-time';
import deviceUtil from 'scripts/utils/device';

import { showLiveVideoModal } from 'components/live-video-modal/live-video-modal';

Component.extend({
    tag: 'viewing-schedule-table-cell-live',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            event: {
                Type: can.Map,
                Value: can.Map,
            },
            liveCard: {
                Type: can.Map,
                Value: can.Map,
            },
            isMultiline: {
                get() {
                    const event = this.attr('event');
                    return (
                        event &&
                        ((event.playerTagGroups &&
                            event.playerTagGroups.length > 3) ||
                            (event.holeTags && event.holeTags.length > 3))
                    );
                },
            },
            text: {
                get() {
                    const event = this.attr('event');
                    if (event.playerTagGroups) {
                        return this.getPlayerNames(event.playerTagGroups)
                            .map((player) => player.replace(/ /g, '\u00a0'))
                            .join(', ');
                    } else if (event.holeTags) {
                        return event.holeTags
                            .map((hole) => `Hole\u00a0${hole.title}`)
                            .join(', ');
                    } else if (event.title) {
                        return event.title;
                    }
                },
            },
        },
        getPlayerNames(playerTagGroup) {
            return playerTagGroup.map((player) =>
                this.shortenName(player.title),
            );
        },
        getTimeWithMeridian: dateTimeUtil.getTimeWithMeridian,
        shortenName: stringUtil.shortenName,
        upperCased: (string) => string.toUpperCase(),
        isLive() {
            return this.attr('event').streamState === 'live';
        },

        onLiveCardClick(liveCard) {
            if (deviceUtil.isMobileWeb) {
                showLiveVideoModal();
            } else {
                if (this.attr('liveCard.channelIdentifier') === 'audio') {
                    window.location.href =
                        window.globalSettings.pagePaths.listen;
                    return;
                }
                window.location = liveVideoService.getLiveUrl(
                    liveCard.video.identifier,
                );
            }
        },
    },
});
